const B_1 = [
    {
        title: '项目管理',
        path: '/revision/project/list'
    }
]

export default {
    path: '',
    component: () => import(/*webpackChunkName: 'revision-project'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'revision-project'*/'@views/bidding/views/project-revision/project/list'),
            meta: {
                title: '项目列表',
                topNav: true,
                bread: B_1
            },
        }
    ]
}
